"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateBlockCenter = void 0;
/**
 * Calculate the position of the center of a block.
 *
 * @includeExample ./src/calculate-block-center.example.ts
 */
function calculateBlockCenter(block) {
    return {
        x: block.x + (block.w / 2),
        y: block.y + (block.h / 2),
        h: 0,
        w: 0
    };
}
exports.calculateBlockCenter = calculateBlockCenter;
